// layouts/CalendarLayout.js
import React, { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import CalendarNavbar from "./CalendarNavbar";
import CalendarNavbarSpaces from "./CalendarNavbarSpaces";
import CalendarHeaderIllustration from "./CalendarHeaderIllustration";
import styles from "./styles.module.scss";

const CalendarLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeSpaceId, setActiveSpaceId] = useState(null);
  // Change default from "%7Bid%7D" (No Group) to "all_spaces" (All Spaces)
  const [selectedPlaceGroupId, setSelectedPlaceGroupId] = useState("all_spaces");
  // Set showAllBookings to true by default
  const [showAllBookings, setShowAllBookings] = useState(true);

  const shouldShowSpacesNavbar =
    location.pathname === "/calendar" ||
    location.pathname.includes("/calendar/timetable");

  return (
    <div className={`pageContainer ${styles.calendarLayout}`}>
      <div className={styles.sidebar}>

        <CalendarNavbar />

        {shouldShowSpacesNavbar && (
          <>
            <CalendarNavbarSpaces
              activeSpaceId={activeSpaceId}
              setActiveSpaceId={setActiveSpaceId}
              selectedPlaceGroupId={selectedPlaceGroupId}
              setSelectedPlaceGroupId={setSelectedPlaceGroupId}
              onShowAllBookings={setShowAllBookings}
              showAllBookings={showAllBookings}
            />
          </>
        )}
      </div>

      <div className={styles.mainContent}>
        <Outlet context={{ 
          activeSpaceId, 
          selectedPlaceGroupId,
          showAllBookings
        }} />
      </div>
    </div>
  );
};

export default CalendarLayout;